import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import CategorySlider from "../../CategorySlider";

const Sitemap = () => {
  return (
    <>
      <Helmet>
        <title>Sitemap | LushDesire India – All Pages, Categories & Delivery Locations</title>

        <meta
          name="description"
          content="Explore complete sitemap of LushDesire India. Browse all sex toy categories, men & women products, couples toys, blogs, policies, and state-wise delivery pages across India."
        />

        <meta
          name="keywords"
          content="lushdesire sitemap, sex toys sitemap india, adult toy website sitemap, sex toys categories india, adult store sitemap"
        />

        <link rel="canonical" href="https://lushdesire.in/sitemap" />

        {/* SEO Schema */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebPage",
            "name": "LushDesire Sitemap",
            "url": "https://lushdesire.in/sitemap",
            "description": "Full sitemap of LushDesire India with all category, blog, policy and delivery pages."
          })}
        </script>
      </Helmet>

      <div style={{ backgroundColor: "#FFF5F5" }}>
        <CategorySlider />

        <div
          style={{
            maxWidth: "1200px",
            margin: "0 auto",
            padding: "40px 20px",
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))",
            gap: "30px",
          }}
        >
          {/* PAGE HEADING */}
          <div style={{ gridColumn: "1 / -1" }}>
            <h1>LushDesire Sitemap – Browse All Pages, Categories & Locations</h1>
            <p>
              This sitemap helps users and search engines explore all 
              <strong> product categories, men & women collections, couples toys, blogs, policies, and India-wide delivery pages</strong> 
              available on LushDesire. Find premium pleasure products with discreet delivery across India.
            </p>
          </div>

          {/* SHOP BY GENDER */}
          <div>
            <h3>Shop By Gender</h3>
            <ul>
              <li><Link to="/women">Sex Toys for Women</Link></li>
              <li><Link to="/men">Sex Toys for Men</Link></li>
              <li><Link to="/couples">Sex Toys for Couples</Link></li>
            </ul>
          </div>

          {/* MEN PRODUCTS */}
          <div>
            <h3>Men’s Products</h3>
            <ul>
              <li><Link to="/masturbators">Masturbators for Men</Link></li>
              <li><Link to="/penis-enhancement">Penis Enhancement Products</Link></li>
              <li><Link to="/cock-rings">Cock Rings</Link></li>
              <li><Link to="/sex-dolls">Sex Dolls</Link></li>
            </ul>
          </div>

          {/* WOMEN PRODUCTS */}
          <div>
            <h3>Women’s Products</h3>
            <ul>
              <li><Link to="/vibrators">Vibrators for Women</Link></li>
              <li><Link to="/dildos">Dildos</Link></li>
              <li><Link to="/massagers">Body Massagers</Link></li>
              <li><Link to="/strap-on">Strap-On Toys</Link></li>
            </ul>
          </div>

          {/* BDSM / KINK */}
          <div>
            <h3>KINK / BDSM</h3>
            <ul>
              <li><Link to="/bondage">Bondage Toys</Link></li>
              <li><Link to="/bdsm">BDSM Products</Link></li>
              <li><Link to="/soft-play">Soft Play Toys</Link></li>
            </ul>
          </div>

          {/* SEX ESSENTIALS */}
          <div>
            <h3>Sex Essentials</h3>
            <ul>
              <li><Link to="/lubricants">Lubricants</Link></li>
              <li><Link to="/delay-products">Delay Products</Link></li>
              <li><Link to="/massage-oils">Massage Oils</Link></li>
            </ul>
          </div>

          {/* COMPANY INFO */}
          <div>
            <h3>Company Info</h3>
            <ul>
              <li><Link to="/about">About Us</Link></li>
              <li><Link to="/blog">Blog</Link></li>
              <li><Link to="/contact">Contact</Link></li>
            </ul>
          </div>

          {/* CUSTOMER POLICIES */}
          <div>
            <h3>Customer Policies</h3>
            <ul>
              <li><Link to="/privacy-policy">Privacy Policy</Link></li>
              <li><Link to="/terms-conditions">Terms & Conditions</Link></li>
              <li><Link to="/refund-policy">Refund Policy</Link></li>
              <li><Link to="/discreet-delivery">Discreet Delivery</Link></li>
            </ul>
          </div>

          {/* DELIVERY PAGES */}
          <div style={{ gridColumn: "1 / -1" }}>
            <h2>Sex Toys Delivery Across India – State Pages</h2>
            <p>
              LushDesire delivers premium adult toys across 
              <strong> Delhi, Maharashtra, Gujarat, Karnataka, Uttar Pradesh, Rajasthan, Punjab, Tamil Nadu, Telangana, Odisha, Kerala, Bihar, Haryana, Himachal Pradesh, Jharkhand, Chhattisgarh & more</strong>.
            </p>

            <ul style={{ columns: 2 }}>
              <li><Link to="/sex-toys-in-delhi">Sex Toys in Delhi</Link></li>
              <li><Link to="/sex-toys-gujarat">Sex Toys in Gujarat</Link></li>
              <li><Link to="/sex-toys-maharashtra">Sex Toys in Maharashtra</Link></li>
              <li><Link to="/sex-toys-uttar-pradesh">Sex Toys in Uttar Pradesh</Link></li>
              <li><Link to="/sex-toys-west-bengal">Sex Toys in West Bengal</Link></li>
              <li><Link to="/sex-toys-haryana">Sex Toys in Haryana</Link></li>
              <li><Link to="/sex-toys-karnataka">Sex Toys in Karnataka</Link></li>
              <li><Link to="/sex-toys-punjab">Sex Toys in Punjab</Link></li>
              <li><Link to="/sex-toys-rajasthan">Sex Toys in Rajasthan</Link></li>
              <li><Link to="/sex-toys-andhra-pradesh">Sex Toys in Andhra Pradesh</Link></li>
              <li><Link to="/sex-toys-tamil-nadu">Sex Toys in Tamil Nadu</Link></li>
              <li><Link to="/sex-toys-kerala">Sex Toys in Kerala</Link></li>
              <li><Link to="/sex-toys-uttarakhand">Sex Toys in Uttarakhand</Link></li>
              <li><Link to="/sex-toys-bihar">Sex Toys in Bihar</Link></li>
              <li><Link to="/sex-toys-madhya-pradesh">Sex Toys in Madhya Pradesh</Link></li>
              <li><Link to="/sex-toys-goa">Sex Toys in Goa</Link></li>
              <li><Link to="/sex-toys-himachal-pradesh">Sex Toys in Himachal Pradesh</Link></li>
              <li><Link to="/sex-toys-jharkhand">Sex Toys in Jharkhand</Link></li>
              <li><Link to="/sex-toys-chhattisgarh">Sex Toys in Chhattisgarh</Link></li>
              <li><Link to="/sex-toys-odisha">Sex Toys in Odisha</Link></li>
              <li><Link to="/sex-toys-telangana">Sex Toys in Telangana</Link></li>
            </ul>
          </div>

          {/* SEO FOOTER TEXT */}
          <div style={{ gridColumn: "1 / -1" }}>
            <h2>Explore Premium Adult Toys Online in India</h2>
            <p>
              LushDesire is India’s trusted online store for 
              <strong> adult toys, men’s pleasure products, women’s vibrators, couples toys, condoms, lubricants, massagers & wellness products</strong>. 
              Shop safely with <strong>100% discreet delivery, COD support, secure payments, and fast shipping across India</strong>.
            </p>
          </div>

        </div>
      </div>
    </>
  );
};

export default Sitemap;
